import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

import { BaseCareerListItem, SelectedTag } from "@features/ui";

import "./pathway.list-item.scss";

export const PathwayListItem = ({ careerPlan, onDownloadClicked }) => {
  const { career, deletedAt } = careerPlan;

  const icon = (
    <FontAwesomeIcon
      role="button"
      title="Download"
      tabIndex={0}
      className="download-icon"
      icon={["fasr", "download"]}
      onClick={() => onDownloadClicked(careerPlan)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onDownloadClicked(careerPlan);
        }
      }}
    />
  );

  const tags = deletedAt
    ? undefined
    : [<SelectedTag key="latest-tag" text={"latest"} />];

  const listItem = (
    <BaseCareerListItem
      className="pathway-item"
      icon={icon}
      career={career}
      tags={tags}
    />
  );

  return listItem;
};

PathwayListItem.propTypes = {
  careerPlan: PropTypes.object.isRequired,
  className: PropTypes.string,
  onDownloadClicked: PropTypes.func,
};
